import React from "react";
import { useParams } from "react-router-dom";
import { ContentCard } from "../../components/ContentCard";
import { CompositeAssets } from "../../components/comparablesSummary/CompositeAssets";
import { LinkForButton } from "../../components/links/LinkForButton";
import { Button } from "@mui/material";
import { CenteredContentWrapper } from "../../components/wrappers/CenteredContentWrapper";
import { useTranslation } from "react-i18next";

interface PropertyDetailsNextRouteProps {}

export const PropertyDetailsNextRoute: React.FC<
  PropertyDetailsNextRouteProps
> = () => {
  const { propertyId } = useParams();
  const { t } = useTranslation();

  if (!propertyId) {
    return null;
  }

  return (
    <div>
      <ContentCard title={t("propertyDetails.compositeAssets.title")}>
        <CompositeAssets
          propertyId={propertyId}
          hideValue
          shouldCheckForUniqueNr
        />
      </ContentCard>
      <CenteredContentWrapper>
        <LinkForButton to={`/properties/${propertyId}`}>
          <Button
            style={{ width: "200px", marginTop: "20px" }}
            variant="contained"
          >
            {t("common.continue")}
          </Button>
        </LinkForButton>
      </CenteredContentWrapper>
    </div>
  );
};
